export default class CountryModel {
  code: string = "";
  name: string = ""

  constructor(obj?: Partial<CountryModel>) {
    if (obj) {
      Object.assign(this, obj)
    }
  }
}